<template>
  <b-form-group :label="label">
    <b-input-group class="input-group-merge">
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input
        v-model="searchInput"
        :placeholder="placeholder"
      />
    </b-input-group>
  </b-form-group>
</template>

<script>
import {
  BInputGroup, BInputGroupPrepend, BFormInput, BFormGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BInputGroup, BInputGroupPrepend, BFormInput, BFormGroup,
  },
  props: {
    label: String,
    placeholder: {
      type: String,
      required: false,
      default: 'Search',
    },
  },
  data() {
    return {
      searchInput: '',
      timer: null,
    }
  },
  watch: {
    searchInput(newvalue) {
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.$emit('callback', newvalue)
      }, 500)
    },
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
}
</script>

<style>

</style>
